import queryString from 'query-string'

import { TagTypes, emptySplitApi } from 'emptySplitApi'
import { SessionId } from 'store/apiHeaders/types'

import { AreasQueryParams } from 'store/area/types'

import { AssessmentChanges, AuditArea, Company, Survey } from './types'

// TODO: once all calls in the account reducer are converted to use
// RTK Query, rename this file to auditApi

export const auditApi = emptySplitApi.injectEndpoints({
  endpoints: build => ({
    getIsScorable: build.query<boolean, { sessionId: SessionId }>({
      query: ({ sessionId }) => ({
        url: `/audit/scorable`,
        headers: {
          'fairhq-session': sessionId ? sessionId.toString() : '',
        },
      }),
      providesTags: [TagTypes.SCORABLE],
    }),

    getAuditSurvey: build.query<Survey, { sessionId: SessionId }>({
      query: ({ sessionId }) => ({
        url: `audit/survey`,
        headers: {
          'fairhq-session': sessionId ? sessionId.toString() : '',
        },
      }),
      keepUnusedDataFor: 0,
    }),
    getAuditCompany: build.query<Company, { sessionId: SessionId }>({
      query: ({ sessionId }) => ({
        url: `audit/company`,
        headers: {
          'fairhq-session': sessionId ? sessionId.toString() : '',
        },
      }),
      keepUnusedDataFor: 0,
    }),
    getAuditAreas: build.query<
      AuditArea[],
      { sessionId: SessionId; query: AreasQueryParams }
    >({
      query: ({ sessionId, query }) => ({
        url: `areas?${queryString.stringify(query as any)}`,
        headers: {
          'fairhq-session': sessionId ? sessionId.toString() : '',
        },
      }),
    }),
    getAssessmentChanges: build.query<AssessmentChanges[], void>({
      query: () => ({
        url: 'assessments/changes',
      }),
    }),
  }),
})

export const {
  useGetIsScorableQuery,
  useGetAuditSurveyQuery,
  useGetAuditCompanyQuery,
  useGetAuditAreasQuery,
  useGetAssessmentChangesQuery,
} = auditApi
